// HISTÓRICO CONGELADO F3c (proyeccionCierres): copia literal del cálculo anterior de cierres de hardware y
// cartelería de la Proyección de ventas. Producción lo usa para los meses < CORTE_HISTORICO (2026-10).
import { convertirAMonedaLocal } from "../../exchangeRateService";

// Cierres Hardware genérico (100% y Activo = ya cerrados)
export const calcCierresHWHistorico = (data, paisParam, ano) => {
  const valores = Array(12).fill(0);
  data
    .filter((n) => n.incluye_hardware && !n.eliminada && ["100%", "Activo"].includes(n.estado) && n.fecha_cierre)
    .forEach((n) => {
      const fecha = new Date(n.fecha_cierre + "T00:00:00");
      if (fecha.getFullYear() === ano) {
        const defaultMoneda = paisParam === "Chile" ? "UF" : "PEN";
        const moneda = (n.moneda_hardware || defaultMoneda).toUpperCase();
        const ultimoDia = new Date(ano, fecha.getMonth() + 1, 0);
        const fechaConversion = ultimoDia.toISOString().split("T")[0];
        const montoHW = Number(n.monto_hardware) || 0;
        valores[fecha.getMonth()] += convertirAMonedaLocal(montoHW, moneda, paisParam, fechaConversion);
      }
    });
  return valores;
};

// Cierres Cartelería genérico (necesita país para conversión)
export const calcCierresCartHistorico = (data, paisParam, ano) => {
  const valores = Array(12).fill(0);
  data
    .filter((n) => !n.eliminada && ["100%", "Activo"].includes(n.estado))
    .forEach((n) => {
      const defaultMoneda = paisParam === "Chile" ? "UF" : "PEN";

      // Cierre del contrato base (gestión + contenidos si no tiene rango separado)
      if (n.fecha_cierre) {
        const fecha = new Date(n.fecha_cierre + "T00:00:00");
        if (fecha.getFullYear() === ano) {
          const pantallas = parseInt(n.cantidad_pantallas) || 1;
          const plazo = parseInt(n.plazo_contrato_meses) || 0;
          const gestion = parseFloat(n.fee_gestion_unitario) || 0;
          const contenidos =
            n.incluye_contenidos && !n.contenidos_fecha_inicio ? parseFloat(n.fee_contenidos_unitario) || 0 : 0;

          const monedaGestion = (n.moneda_gestion || defaultMoneda).toUpperCase();
          const monedaContenidos = (n.moneda_contenidos || defaultMoneda).toUpperCase();
          const ultimoDiaMes = new Date(ano, fecha.getMonth() + 1, 0);
          const fechaConversion = ultimoDiaMes.toISOString().split("T")[0];

          const gestionLocal = convertirAMonedaLocal(gestion * pantallas, monedaGestion, paisParam, fechaConversion);
          const contenidosLocal = convertirAMonedaLocal(
            contenidos * pantallas,
            monedaContenidos,
            paisParam,
            fechaConversion
          );
          const montoTotal = (gestionLocal + contenidosLocal) * plazo;

          valores[fecha.getMonth()] += montoTotal;
        }
      }

      // Cierre adicional de contenidos con fecha de inicio propia
      if (n.incluye_contenidos && n.contenidos_fecha_inicio) {
        const fechaCont = new Date(n.contenidos_fecha_inicio + "T00:00:00");
        if (fechaCont.getFullYear() === ano) {
          const pantallas = parseInt(n.cantidad_pantallas) || 1;
          const contenidos = parseFloat(n.fee_contenidos_unitario) || 0;
          const monedaContenidos = (n.moneda_contenidos || defaultMoneda).toUpperCase();
          const ultimoDiaMes = new Date(ano, fechaCont.getMonth() + 1, 0);
          const fechaConversion = ultimoDiaMes.toISOString().split("T")[0];

          // Plazo contenidos = meses entre inicio y fin
          const fechaFin = n.contenidos_fecha_fin ? new Date(n.contenidos_fecha_fin + "T00:00:00") : null;
          const plazoCont = fechaFin
            ? (fechaFin.getFullYear() - fechaCont.getFullYear()) * 12 + fechaFin.getMonth() - fechaCont.getMonth() + 1
            : parseInt(n.plazo_contrato_meses) || 0;

          const contenidosLocal = convertirAMonedaLocal(
            contenidos * pantallas,
            monedaContenidos,
            paisParam,
            fechaConversion
          );
          valores[fechaCont.getMonth()] += contenidosLocal * plazoCont;
        }
      }
    });
  return valores;
};
